import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fg } from '@atlaskit/platform-feature-flags';
import { getAnalyticsClient, isSSR, Logger } from '../../../common/utils';
import { getBscGlobalState, initializeGlobalState } from '../../../common/utils/bsc-global-state';
import { WebStorageType } from '../../../services/web-storage-service';
import { createDocumentCookiePassthrough } from './create-document-cookie-passthrough';
import { createWebStoragePassthrough } from './create-web-storage-passthrough';
export var initializeControls = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var args,
      analyticsWebClientInstance,
      isAnalyticsInitialized,
      isWebStorageControlsEnabled,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          if (!fg('platform_moonjelly_bsc_master_killswitch')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.prev = 3;
          initializeGlobalState(args);

          // Exit silently if in SSR context
          if (!isSSR()) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          // Ensures that the AWC is constructed before overwriting any native methods.
          analyticsWebClientInstance = getAnalyticsClient(); // If AWC is not initialized, it will be undefined
          isAnalyticsInitialized = !!analyticsWebClientInstance;
          if (isAnalyticsInitialized) {
            _context.next = 11;
            break;
          }
          throw new Error("Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.");
        case 11:
          _context.next = 13;
          return createDocumentCookiePassthrough();
        case 13:
          isWebStorageControlsEnabled = getBscGlobalState().webStorageEnabled;
          if (isWebStorageControlsEnabled) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("return");
        case 16:
          _context.next = 18;
          return createWebStoragePassthrough(WebStorageType.LocalStorage);
        case 18:
          _context.next = 20;
          return createWebStoragePassthrough(WebStorageType.SessionStorage);
        case 20:
          _context.next = 25;
          break;
        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](3);
          Logger.errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: "Failed to initialize browser storage controls. ".concat(_context.t0.message || '')
          });
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 22]]);
  }));
  return function initializeControls() {
    return _ref.apply(this, arguments);
  };
}();
export { createDocumentCookiePassthrough, createWebStoragePassthrough };